export default __webpack_public_path__ + "static/media/23.c75a3f00.png";